<template>
  <div>
    <abbonamento v-if="user.tipologia === 'professionista'" :utente="user" />
  </div>
</template>
<script>
import Abbonamento from "@/components/Abbonamento";
export default {
  name: "impostazioni",
  props: ["utente"],
  components: { Abbonamento },
  data() {
    return {
      user: this.utente
    };
  },
  created() {
    // console.log(this.utente);
  }
};
</script>